module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17852/js/img/valuePropModals/FormConditionalLogic/ValueProp1.svg"